import { FC } from 'react';
import { cx } from '@emotion/css';
import Skeleton from 'react-loading-skeleton';

import { GalleryImage, ImagesGallery } from '@phoenix/core/frontend/shared/ui/images/images-gallery/images-gallery';
import { ProductDetails, ProductListItem } from '@phoenix/team-m/my-tool-shed/frontend/util/product/product.model';

import { ProductImage } from '../product-image';
import styles from './tool-info.module.scss';

interface ToolImageProps {
  product?: ProductListItem | ProductDetails;
  isLoading?: boolean;
  images?: GalleryImage[];
  imageClassName?: string;
  uploadErrorMessage?: string;
  onAddImage?: (files: File) => void;
  onDeleteImage?: (imageId: string) => void;
  onSetMainImage?: (imageId: string) => void;
  placeholderImageClassName?: string;
  suppressGird?: boolean;
  sizes?: string;
}

export const ToolImage: FC<React.PropsWithChildren<ToolImageProps>> = ({
  product = {} as ProductDetails,
  isLoading = false,
  images = [],
  imageClassName = '',
  onAddImage,
  onDeleteImage,
  onSetMainImage,
  uploadErrorMessage,
  placeholderImageClassName = 'h-8',
  suppressGird = false,
  sizes,
}) => {
  const showImagesGallery = onAddImage && onDeleteImage;

  if (isLoading)
    return (
      <div className={cx(suppressGird || styles.productImage)}>
        <Skeleton className={imageClassName} />
      </div>
    );

  return showImagesGallery ? (
    <ImagesGallery
      images={images}
      imageViewerTitle={product.customName ?? product.productName}
      className={styles.productImage}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      onSetMainImage={onSetMainImage}
      galleryErrorMessage={uploadErrorMessage}
    />
  ) : (
    <ProductImage
      imageSrc={product.images.main}
      imageAlt={product.productCategory?.name}
      className={cx(suppressGird || styles.productImage, imageClassName)}
      placeholderImgClassName={placeholderImageClassName}
      sizes={sizes}
    />
  );
};
